import { render, staticRenderFns } from "./SupplierManagement.vue?vue&type=template&id=681f207d&scoped=true"
import script from "./SupplierManagement.vue?vue&type=script&lang=js"
export * from "./SupplierManagement.vue?vue&type=script&lang=js"
import style0 from "./SupplierManagement.vue?vue&type=style&index=0&id=681f207d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f207d",
  null
  
)

export default component.exports